import { SecondaryLinkButton } from '@luminalearning/components';
import Skeleton from 'react-loading-skeleton';

const QualificationContainerSkeleton = () => (
    <div
        className={[
            'h-96 flex w-qual flex-col items-center bg-white border-1-5 border-card-normal rounded-md mr-6 mb-6',
        ].join(' ')}
    >

        <div className='mt-4 mb-2'>
            <span className={'text-label-lg font-bold'}>
                <Skeleton style={{ width: '10rem', height: '2rem' }} baseColor='#d7d7d7' highlightColor='#c8c8c8'/>
            </span>
        </div>
        <div className='w-auto h-10 flex flex-row justify-center items-center p-alert rounded-md'>
            <Skeleton style={{ width: '10rem' }} baseColor='#d7d7d7' highlightColor='#c8c8c8'/>

        </div>
        <div>
            <Skeleton
                circle={true} style={{ width: '170px', height: '170px' }}
                baseColor='#d7d7d7' highlightColor='#c8c8c8'
                className='mt-8 mb-8'

            />
        </div>
        <div className='flex flex-row justify-center items-center font-bold text-paragraph-reg'>
            <SecondaryLinkButton
                direction='Right'
                href=''
                hasArrow={true}
                isLoading={true}
                className='h-9 text-sm' target='_blank' rel='noreferrer'></SecondaryLinkButton>
        </div>

    </div>

);

export default QualificationContainerSkeleton;